var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"tag",class:{
       'tag--red': _vm.isRed,
       'tag--blue': _vm.isBlue
   }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }